var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterLevel1MRFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 76,
    viewBox: "0 0 105 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0818718 52.1538L0.0639 58.0486C0.0639 58.0486 -0.834694 61.6429 4.10757 62.9908C9.04984 64.3387 4.55687 62.9908 4.55687 62.9908L45.8922 74.6726C45.8922 74.6726 50.3851 76.4697 53.9795 75.5711L54.4288 64.788L20.7316 45.4683L0.0818718 52.1538Z",
    fill: "#946E3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.402 49.4579C103.402 49.5118 103.852 55.802 103.852 55.802C103.852 55.802 104.75 59.3963 102.504 60.7442C102.504 60.7442 61.6178 74.2231 61.1685 74.2231C60.7192 74.2231 56.2262 75.1217 53.9797 75.571V62.0921L103.402 49.4579Z",
    fill: "#8B6838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23921 48.5547C7.23921 48.5547 -7.46628 52.4771 5.23534 54.436L45.3486 64.8912C45.3486 64.8912 53.7953 69.0966 63.7338 64.2397C64.4032 63.9117 100.504 51.8211 100.504 51.8211C100.504 51.8211 107.859 49.2062 99.1653 46.2678L60.391 33.5258C60.391 33.5258 54.3749 31.5668 48.6913 34.5052L7.2437 48.5547H7.23921Z",
    fill: "#9F753F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5749 49.3231C18.5749 49.3231 7.36945 52.576 17.1102 53.9733L47.923 61.7372C47.923 61.7372 54.4333 64.9451 61.9815 61.0093C62.4892 60.7442 89.9682 50.8193 89.9682 50.8193C89.9682 50.8193 95.5619 48.6761 88.8809 46.4656L59.061 36.891C59.061 36.891 54.4333 35.4174 50.12 37.7986L18.5749 49.3276V49.3231Z",
    fill: "#B08245"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0056 54.0767C41.79 51.7448 43.6276 32.16 44.4857 21.0309C44.4857 21.0309 35.4459 24.1625 34.5428 23.9693C33.9857 23.866 31.829 12.5617 32.0537 12.2921C33.3971 10.9622 50.1019 5.46278 51.8138 5C53.3459 5.22914 58.8992 6.46471 59.8337 7.3633C59.8337 7.3633 57.2413 52.0773 56.6572 54.8585C56.0147 55.0337 42.4549 54.809 42.0056 54.0812V54.0767Z",
    fill: "#B08245",
    stroke: "#B08245",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0056 54.0767C41.79 51.7448 43.6276 32.16 44.4857 21.0309C44.4857 21.0309 35.4459 24.1625 34.5428 23.9693C33.9857 23.866 31.829 12.5617 32.0537 12.2921C33.3971 10.9622 50.1019 5.46278 51.8138 5C53.3459 5.22914 58.8992 6.46471 59.8337 7.3633C59.8337 7.3633 57.2413 52.0773 56.6572 54.8585C56.0147 55.0337 42.4549 54.809 42.0056 54.0812V54.0767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterLevel1MRFinished);
export default __webpack_public_path__ + "static/media/winter_level_1_m_r_finished.a2788048fa2b8cc1d8d05309691f6dbe.svg";
export { ForwardRef as ReactComponent };